module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};



//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/~/ramda/src/internal/_isString.js
// module id = 472
// module chunks = 0